export default "__VITE_ASSET__ec43c656__"